import React from "react";
import { useLocation,useParams } from "react-router-dom";
import Form from "../Form/Form";
import { useSelector } from "react-redux";

const MainForm = ({setFetchMainApi}) => {
  const formname = useLocation();
  const params = useParams();
  const data = useSelector(state => state?.DrawerReducer?.compData);
  const formRoute = formname.pathname + formname.search;
  const formInstanceKey = `${formRoute}:${formname.key || "default"}`;
// console.log(params,formname,'params7');
  // React Router reuses the wildcard route component. Keying the form by its
  // navigation entry gives every form/record navigation a fresh component
  // tree, including Save and New when it targets the same Add URL.
  return <Form key={formInstanceKey} setFetchMainApi={setFetchMainApi} route={formRoute} caption={data?.sCaption} />;
};

export default MainForm;
